export default __webpack_public_path__ + "static/media/logo.e815871b.svg";